import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./EditDepartment.css";
import Header from "../../../../../../header/header";
import Navvbar from "../../../../../../header/Navvbar";

/* ===== Shared-style Settings Sidebar (isi file ke andar) ===== */
const SettingsSidebar = () => (
  <div className="my-sidebar">
    <h2 className="my-sidebar-title">Settings</h2>
    <div className="my-sidebar-links">
      <Link to="/lab-details" className="my-sidebar-link">Lab Details</Link>
      <Link
        to="#"
        onClick={(e) => e.preventDefault()}
        className="my-sidebar-link my-sidebar-disabled"
      >
        Store
      </Link>
      <Link to="/users" className="my-sidebar-link">Users</Link>
      <Link
        to="#"
        onClick={(e) => e.preventDefault()}
        className="my-sidebar-link my-sidebar-disabled"
      >
        Permission Groups
      </Link>
      <Link to="/accountTable" className="my-sidebar-link">Accounts</Link>
      <Link to="/financeOwerview" className="my-sidebar-link">Finances</Link>
      <Link to="/owersetting" className="my-sidebar-link">Case Settings</Link>
    </div>
  </div>
);

const EditDepartment = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    dailyLimit: "",
    customId: "",
  });

  const departmentsOrder = [
    "CROWN AND BRIDGE",
    "ORTHODONTIC",
    "IMPLANTS",
    "All Departments",
  ];

  useEffect(() => {
    // Yahan API se data laa sakte hain
    if (id) {
      setFormData({
        name: "All Departments",
        dailyLimit: "",
        customId: "",
      });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    console.log("Saving Data:", formData);
    alert("Department saved successfully!");
    navigate(-1);
  };

  return (
    <div className="ed-layout">
      <div className="ed-header-container">
        <Header />
        <Navvbar />
      </div>

      <div className="ed-main-wrapper">
        <div className="ed-row">
          {/* ===== SIDEBAR ===== */}
          <div className="ed-sidebar">
            <SettingsSidebar />
          </div>

          {/* ===== CONTENT ===== */}
          <div className="ed-content">
            <h2 className="ed-title">Edit Department</h2>

            {/* Section 1: Department Details */}
            <div className="ed-section">
              <h5 className="ed-section-title ed-section-title-line">
                Department Details
              </h5>
              <div className="ed-form-box">
                <div className="ed-form-row">
                  <label className="ed-form-label">
                    Name <span className="ed-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="ed-form-input"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="ed-form-row">
                  <label className="ed-form-label">Daily Limit</label>
                  <div className="ed-daily-limit-group">
                    <input
                      type="number"
                      name="dailyLimit"
                      className="ed-form-input ed-limit-input"
                      value={formData.dailyLimit}
                      onChange={handleChange}
                    />
                    <span className="ed-limit-text">Task Blocks</span>
                  </div>
                </div>

                <div className="ed-form-row">
                  <label className="ed-form-label">Custom ID</label>
                  <input
                    type="text"
                    name="customId"
                    className="ed-form-input"
                    placeholder="Custom Identifier"
                    value={formData.customId}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {/* Section 2: Departments Order */}
            <div className="ed-section" style={{ marginTop: "20px" }}>
              <h5 className="ed-section-title">Departments Order</h5>
              <div className="ed-order-list">
                {departmentsOrder.map((dept, index) => (
                  <div key={index} className="ed-order-item">
                    {dept}
                  </div>
                ))}
              </div>
            </div>

            {/* Actions - Only Save Button */}
            <div className="ed-actions">
              <button className="ed-btn" onClick={handleSave}>
                <span className="ed-save-icon">💾</span> Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDepartment;